'use strict';
var ua = window.navigator.userAgent;

/**
 * 判断设备是移动设备
 * @returns {boolean}
 */
function isMobileDevice() {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(ua);
}

function isLionScrollBar() {
  return (/iPhone|iPad|iPod|OS X/i).test(ua);
}

/**
 * 判断是否是微信
 * @returns {boolean}
 */
function isWeChat() {
  return (/MicroMessenger/i).test(ua);
}

function isMobileQQBrowser() {
  return (/MQQBrowser/i).test(ua);
}

function isQQ() {
  return (/QQ/i).test(ua) && !isMobileQQBrowser();
}

function getDeviceRatio() {
  return window.devicePixelRatio || 1;
}

function isWebkit() {
  return (/WebKit/i).test(ua);
}

/**
 * is CriOS: ios chrome ua 中包含
 */
function isCriOS() {
  return (/CriOS/i).test(ua);
}

function isUC() {
  return (/UCBrowser/i).test(ua);
}

/**
 * 判断设备是否是 ios
 */
function isiOS() {
  return (/iPhone|iPad|iPod/i).test(ua) && window.navigator.standalone !== undefined; // may be use standalone is not a good habit
}

/**
 * 判断是否是 ios safari
 */
function isiOSSafari() {
  return (/(iPad|iPhone|iPod)/gi).test(ua) && !isCriOS() && !(/FxiOS/).test(ua) && !(/OPiOS/).test(ua) && !(/mercury/).test(ua) && !isUC() && !isQQ() && !isMobileQQBrowser();
}

function isStandalone() {
  return isiOSSafari() && window.navigator.standalone;
}

function isMac() {
  return window.navigator.userAgent.indexOf('Macintosh') !== -1;
}

module.exports = {
  isMobileDevice: isMobileDevice,
  isWeChat: isWeChat,
  isQQ: isQQ,
  isLionScrollBar: isLionScrollBar,
  getDeviceRatio: getDeviceRatio,
  isiOS: isiOS,
  isiOSSafari: isiOSSafari,
  isStandalone: isStandalone,
  isMac: isMac
};



// WEBPACK FOOTER //
// ./src/helper/envHelper.js